module.exports = __webpack_public_path__ + "img/album21_17.a9dd8e4c.jpg";